export default {
  api: {
    error: {
      city: {
        found: "Stad bestaat al."
      }
    }
  }
}
